import { createApiClient } from '@london-life/api-client';
import { createCsrfStore, createFirebaseBrowserAuth } from '@london-life/auth-client';
import { env } from './env';

// the admin app has its own CSRF store and session cookie scope
export const csrf = createCsrfStore('ll_admin_csrf');
// when any request finds the session ended (idle timeout, roles changed, signed out elsewhere) the app
// hears about it here and goes back to the sign-in screen with the reason
export const sessionEnded = new EventTarget();

// when the API asks for a fresh two-step code, the client waits here while the prompt dialog asks the admin;
// it resolves true once they have entered one (the request is then retried), false if they cancel or no
// dialog is mounted
export type TwoStepRequest = (verified: boolean) => void;
const asks = new Set<(resolve: TwoStepRequest) => void>();
export const twoStepRequests = {
  listen(listener: (resolve: TwoStepRequest) => void) {
    asks.add(listener);
    return () => void asks.delete(listener);
  },
  ask: () =>
    new Promise<boolean>((resolve) => {
      const [listener] = asks;
      if (listener) listener(resolve);
      else resolve(false);
    }),
};
export const api = createApiClient({
  baseUrl: env.apiOrigin,
  getCsrfToken: csrf.get,
  onUnauthorized: (message) => sessionEnded.dispatchEvent(new CustomEvent('ended', { detail: message })),
  onTwoStepRequired: twoStepRequests.ask,
});
export const browserAuth = createFirebaseBrowserAuth({
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  appId: env.firebase.appId,
});
